import {
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { LocalServiceService } from '../shareModule/services/local-service.service';
import {
  NgbActiveModal,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { RoleService } from '../shareModule/services/roles/role.service';
import { Subject, takeUntil } from 'rxjs';
import { AppState } from '../shareModule/states/app.state';
import { Store, select } from '@ngrx/store';
import { User } from '../shareModule/models/user.model';
import { selectUser } from '../shareModule/states/user-details';
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { SharedService } from '../shareModule/services/shared.service';
import { AddProductComponent } from '../admin/sub-admin/add-product/add-product.component';
import { ImageModalComponent } from '../shareModule/component/chat/chatbot/image-modal.component';
import { CommonService } from '../shareModule/services/common.service';
import { PopUpService } from '../popupservice.service';
import Swal from 'sweetalert2';
import { Overlay } from '@angular/cdk/overlay';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-product-shop',
  templateUrl: './product-shop.component.html',
  styleUrl: './product-shop.component.scss',
})
export class ProductShopComponent implements OnInit, OnDestroy, OnChanges {
  public _serviceData = null;
  public viewGrid = 'grid';
  public get serviceData() {
    return this._serviceData;
  }
  public shopParam: any = null;
  public set serviceData(val) {
    this._serviceData = val;
    this._getLinkedProducts();
    this._getVariantCategories();
    this.convertedVariations =
      this.serviceData?.memberShopProductsVariations?.map((v) =>
        this.variantToProduct(v)
      );
    // this.convertedVariations.sort((a, b)=>{
    //       const aVal = a.priority ? a.priority : 0;
    //       const bVal = b.priority ? b.priority : 0;

    //       return bVal - aVal

    // })
  }
  public isServiceMode = true;
  public loading = false;
  public imgUrl = environment.ImageUrl;

  public selectedVariantCategory = null;
  public encodedSingleImage = null;
  public selectedNewVariantCategoryImage = null;
  public newVariationCategoryName = '';
  public newVarSelectedCategory = '';
  public newVarCatPriority;

  constructor(
    private local: LocalServiceService,
    private modalService: NgbModal,
    private roleService: RoleService,
    private cdr: ChangeDetectorRef,
    private bottomSheet: MatBottomSheet,
    private store: Store<AppState>,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private sharedService: SharedService,
    private popup: PopUpService,
    private overlay: Overlay,
    private commonService: CommonService,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef,
    private route: ActivatedRoute,
    private router: Router,
    @Optional()
    private modalRef: NgbActiveModal
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    this._getLinkedProducts();
    this._getVariantCategories();
  }
  public searchText = '';
  public filterProducts() {}
  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth < 767;
  }
  showImage(src, text = '', price = '') {
    // this.modalService.dismissAll();
    if (this.isMobile) {
      const ref = this.bottomSheet.open(ImageModalComponent, {
        scrollStrategy: this.overlay.scrollStrategies.block(),
        panelClass: 'bottom-sheet-image',
        data: {
          imageSrc: environment.ImageUrl + src,
          descr: text,
          title: text,
          price: '$ ' + price
        }
      });
    } else {
      const ref = this.modalService.open(ImageModalComponent, {
        size: 'sm',
        windowClass: 'image-modal',
      });
      ref.componentInstance.imageSrc = environment.ImageUrl + src;
      ref.componentInstance.title = text;
      ref.componentInstance.descr = text;
      ref.componentInstance.price = '$ ' + price;
    }

    // setTimeout(this.local.fixModalZIndexes.bind(this));
  }
  showVariations(product) {
    console.log('ffffffff', product);
  }
  public moreContent = false;
  ngOnDestroy(): void {
    this.destroy$.complete();
  }
  private destroy$ = new Subject();
  public user = null;

  goBack() {
    this.bottomSheetRef?.dismiss();
    this.modalRef?.dismiss();
  }

  public openModal(modal) {
    this.modalRef = this.popup.openPopup(modal, {
      forceMode: 'modal',
    }) as NgbModalRef;
  }

  public email = 'kachiing@massive-haiku-457712-i5.iam.gserviceaccount.com';
  public openSheetAddingTutorial(modalRef) {
    this.modalRef = this.modalService.open(modalRef, { size: 'md' });
  }
  public showSheerURL = false;
  public openSheetURLAdder() {
    this.showSheerURL = true;
    this.modalRef?.dismiss();
  }

  public async setNewVariantCategoryImage(event) {
    [this.encodedSingleImage, this.selectedNewVariantCategoryImage] =
      await this.commonService.convertImageToURL(event);
  }

  public copyText(id: string) {
    const text = (document.getElementById(id)?.innerText || '') as string;
    navigator.clipboard.writeText(text).then(() => {
      alert('Copied to clipboard!');
    });
  }
  public readonly appScriptCode = `
        function onEdit(e) {
                  var sheet = e.range.getSheet();
                  var aValue = sheet.getRange(e.range.getRow(), 1).getValue();

                  var data = {
                    spreadsheetId: e.source.getId(),        // the spreadsheet's unique ID
                    sheetId: sheet.getSheetId(),            // the tab's internal sheet ID (gid)
                    sheetName: sheet.getName(),             // the tab name
                    range: e.range.getA1Notation(),         // which cells were edited
                    value: e.value,                         // new value
                    A: aValue
                  };

                  var url = "https://api.kachiing.com/adminApp/googleSheetWebhook"; // your endpoint
                  var options = {
                    method: "post",
                    contentType: "application/json",
                    payload: JSON.stringify(data)
                  };

                  UrlFetchApp.fetch(url, options);
                }
 `;
  public tutorialSwiper = null;
  test(x) {
    console.log(x);
  }
  public async setProductGoogleSheet(value: string) {
    const appScript = `
        
           function onEdit(e) {
            var sheet = e.range.getSheet();
            var aValue = sheet.getRange(e.range.getRow(), 1).getValue();

            var data = {
              spreadsheetId: e.source.getId(),        // the spreadsheet's unique ID
              sheetId: sheet.getSheetId(),            // the tab's internal sheet ID (gid)
              sheetName: sheet.getName(),             // the tab name
              range: e.range.getA1Notation(),         // which cells were edited
              value: e.value,                         // new value
              A: aValue
            };

            var url = "https://api.kachiing.com/adminApp/googleSheetWebhook"; // your endpoint
            var options = {
              method: "post",
              contentType: "application/json",
              payload: JSON.stringify(data)
            };

            UrlFetchApp.fetch(url, options);
          }

    `;

    this.auth
      .setProductProperty(this.serviceData?.id, 'shopGoogleSheetId', value)
      .subscribe({
        next: () => {
          this.toastr.success('Changed!');
        },
        error: (error) => {
          this.toastr.error(error.error.message);
        },
      });
  }
  public variantCategories = [];
  public _getVariantCategories() {
    this.auth.getVariantCategories(this.serviceData?.id).subscribe({
      next: (data) => {
        this.variantCategories = data.body;

        if (this.variantCategories.length) {
          //console.log('set variant id to',  this.variantCategories[0])
          this.newVarSelectedCategory = this.variantCategories[0].id;
        }
      },
    });
  }
  public submitVariationCategory() {
    let subs;
    if (this.isEdtingVariantCategory) {
      //subs = this.auth.editVariantCategory(fd)
      subs = this.auth.editVariantCategory({
        categoryId: this.selectedVariantCategory?.id,
        name: this.newVariationCategoryName,
        priority: this.newVarCatPriority,
      });
      // subs = this.auth.editVariationOfProduct({
      //   variantId: this.selectedVariant?.id,  varPrice: this.newVarPrice, varName: this.newVarName, varDescr: this.newVarDescr
      // })
    } else {
      subs = this.auth.createVariantCategory(
        this.serviceData?.id,
        this.selectedNewVariantCategoryImage,
        this.newVariationCategoryName,
        this.newVarCatPriority
      );
    }

    subs.subscribe({
      next: () => {
        this.toastr.success('done!');
        this.modalRef?.close();
        this.refresh();
      },
      error: (error) => {
        this.toastr.error(error.error.message);
      },
    });
  }

  @ViewChild('AddShop') addProductComponent: AddProductComponent;
  openAddProduct() {
    this.bottomSheet.dismiss();
    this.addProductComponent.isRecommendedProduct = true;
    this.addProductComponent.memberShopProductType = 'shop';
    this.addProductComponent.newProduct({closeAll: true, addedToProductPage: this.serviceData});
  }
  public handleWhatsapp() {
    let phone = this.serviceData?.appUser.phone;
    if (
      this.serviceData?.shoutContact &&
      this.serviceData?.shoutContact != 'null'
    ) {
      phone = this.serviceData?.shoutContact;
    }
    window.open(`https://wa.me/${phone}`, '_blank');
  }
  support(productData) {
    if (!productData) {
      return;
    }
    this.auth
      .marketplace_favorite_product({
        foodId: this.serviceData?.id,
        isAdmin: 0,
      })
      .subscribe({
        next: () => {
          this.serviceData.isFavorite = !this.serviceData.isFavorite;
          if (this.serviceData?.isFavorite) {
            this.toastr.success('Supported');
          } else {
            this.toastr.success('Unsupported');
          }
          this.sharedService.refreshProductId.next({
            action: 'edited',
            productId: this.serviceData?.id,
          });
        },
      });
  }

  public linkedProducts = [];
  private _getLinkedProducts() {
    this.auth.getLinkedProducts(this.serviceData?.id).subscribe({
      next: (data) => {
        this.linkedProducts = data.body;
      },
      error: console.error,
    });
  }
  public refresh() {
    this._getVariantCategories();

    this._getServiceData();
    this.convertedVariations =
      this.serviceData?.memberShopProductsVariations?.map((v) =>
        this.variantToProduct(v)
      );
    this.convertedVariations.sort((a, b) => {
      const aVal = a.priority ? a.priority : 0;
      const bVal = b.priority ? b.priority : 0;

      return bVal - aVal;
    });
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    //   setTimeout(()=> console.log('sddddd', this.serviceData, ), 2000)
    this.roleService.rolesSubject
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isAdmin = this.roleService?.roles?.userType.includes('ADMIN');
        this.cdr.detectChanges();
      });
    this._getLinkedProducts();

    this.store
      .pipe(select(selectUser))

      .subscribe((response: User) => {
        this.user = response;
      });

      this.route.params.subscribe((params) => {
        this.shopParam = params['shop'];
        if (this.shopParam && parseInt(this.shopParam)) {
          this.auth
          .getShopProductDetails({ productId: parseInt(params['shop']), isForPage: 1 })
          .subscribe({
            next: (data) => {
              this.serviceData = data.body;
    
              this.cdr.detectChanges();
            },
            error: (err) => {
              console.error(err);
              this.toastr.error('Error could not find the product data');
            },
          });
        }
      });
  }

  public isEditingVariant = false;
  public selectedVariant = null;
  public imageVariant = null;
  public openEditVariant(variant) {
    this.newVarDescr = variant.descr;
    this.selectedVariant = variant;
    this.newVarName = variant.name;
    this.newVarPrice = variant.price;
    this.newVarPriority = variant.priority;
    this.imageVariant = variant.indexImage;
    this.openAddVariation(true);
  }
  public deleteVariant() {
    this.auth.deleteVariationOfProduct(this.selectedVariant?.id).subscribe({
      next: () => {
        this.toastr.success('Deleted');
        this.refresh();
      },
    });
  }
  public encodedBannerImage = null;
  @ViewChild('changeProductPageInfo')
  public changeProductPageInfo: TemplateRef<any>;
  private selectedBannerImage: File | null = null;
  public setBannerImage(event) {
    const file = event.target.files[0];
    this.selectedBannerImage = file;

    const fr = new FileReader();
    fr.onload = (event: any) => {
      this.encodedBannerImage = event.target.result;
    };
    fr.readAsDataURL(file);
  }
  @ViewChild('bannerImageSelector')
  public bannerImageSelector;
  public selectBannerImages(e) {
    e.stopPropagation();
    const nativeFileSelector = this.bannerImageSelector.nativeElement;
    nativeFileSelector.click();
  }

  @ViewChild('profileImageSelector')
  public profileImageSelector;
  public encodedProfileImage = null;
  public selectProfileImage(e) {
    e.stopPropagation();
    const nativeFileSelector = this.profileImageSelector.nativeElement;
    nativeFileSelector.click();
  }

  public timeAgo(time) {
    return this.local.timeAgo(time);
  }

  public memberShopProductsVariations = [];

  public convertedVariations = [];
  @ViewChild('addVariation') addVariationModal: TemplateRef<any>;
  public openAddVariation(isEditingVariant = false) {
    this.isEditingVariant = isEditingVariant;
    this.bottomSheetRef = this.bottomSheet.open(this.addVariationModal, {
      panelClass: 'add-variation',
    });
  }
  public clickVarImageSelector() {
    document.getElementById('varImageSelector').click();
  }
  public setNewVarCategory(catId) {
    console.log('setting variant of new cat id ', catId);
    this.newVarSelectedCategory = catId;
  }
  public isEdtingVariantCategory = false;
  public newVarCatImage = null;
  public editSelectedCategory(template) {
    console.log('template', template)
    this.isEdtingVariantCategory = true;
    this.newVarCatPriority = this.selectedVariantCategory?.priority;
    this.newVariationCategoryName = this.selectedVariantCategory?.name;
    this.newVarCatImage = this.selectedVariantCategory?.icon;
    this.modalRef = this.modalService.open(template, { size: 'md' });
  }
  public deleteVariantCategory(){
    Swal.fire({title: 'Delete?', text: 'Are your sure?', icon: 'warning'})
    .then((
      res =>{
        if(res.isConfirmed){
             this.auth.deleteVariantCategory(this.selectedVariantCategory?.id).subscribe({
            next: ()=>{
              this.modalRef?.close();
              this.bottomSheetRef?.dismiss()
              this.refresh()
              this.toastr.success("Deleted")
            }
          })

        }
      }
    ))
 
  }
  public submitVariation() {
    const fd = new FormData();
    fd.append('productId', this.serviceData?.id),
      fd.append('varName', this.newVarName);
    fd.append('varDescr', this.newVarDescr);
    fd.append('varPrice', this.newVarPrice);
    fd.append('image', this.selectedVariationImage);
    fd.append('selectedCategoryId', this.newVarSelectedCategory);
    fd.append('priority', this.newVarPriority);
    let subs;
    if (this.isEditingVariant) {
      subs = this.auth.editVariationOfProduct({
        variantId: this.selectedVariant?.id,
        varPrice: this.newVarPrice,
        varName: this.newVarName,
        varDescr: this.newVarDescr,
        priority: this.newVarPriority,
      });
    } else {
      subs = this.auth.addVariationToProduct(fd);
    }

    subs.subscribe({
      next: () => {
        this.bottomSheetRef?.dismiss();
        this.newVarName, (this.newVarPrice = null);
        this.refresh();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error(err.error.message);
      },
    });
  }
  public newVarPrice = null;
  public newVarName = '';
  public newVarDescr = '';
  public newVarPriority;

  public encodedVariationImage = null;
  public selectedVariationImage = '';
  public setVariationImage(event) {
    const file = event.target.files[0];
    this.selectedVariationImage = file;

    const fr = new FileReader();
    fr.onload = (event: any) => {
      this.encodedVariationImage = event.target.result;
    };
    fr.readAsDataURL(file);
  }
  public handleEdit() {
    this.bottomSheetRef?.dismiss();
    this.addProductComponent.memberShopProductType = this.serviceData?.type;
    this.addProductComponent.selectedCatId = this.serviceData?.categoryId;
    this.addProductComponent.selectedCategoryNameForDD =
      this.serviceData?.categoryName;
    this.addProductComponent.selectedsubCatId = this.serviceData?.subCategoryId;
    // this.addProductComponent.selectedSubCategoryName =
    //   this.serviceData?.subCategoryName;
    this.addProductComponent.editProductModal(this.serviceData?.id);
  }
  public variantToProduct(variant) {
    if (!variant) {
      return null;
    }
    const t = {
      id: variant.id,
      variantCategoryId: variant.variantCategoryId,
      name: variant.value,
      indexImage: variant.image || this.serviceData?.indexImage,
      price: variant.key,
      memberShopProductsVariations: [{ key: variant.key }],
      priority: variant.priority,
    };
    //  console.log(t);

    return t;
  }

  private selectedProfileImage = null;

  public setProfileImage(event) {
    const file = event.target.files[0];
    this.selectedProfileImage = file;

    const fr = new FileReader();
    fr.onload = (event: any) => {
      this.encodedProfileImage = event.target.result;
    };
    fr.readAsDataURL(file);
  }
  public submitPageData() {
    const payload = new FormData();
    if (this.selectProfileImage) {
      payload.append('profileImage', this.selectedProfileImage);
    }
    if (this.selectedBannerImage) {
      payload.append('bannerImage', this.selectedBannerImage);
    }
    this.auth.setProductPageInfos(this.serviceData?.id, payload).subscribe({
      next: (data) => {
        this.toastr.success('submited!');
        this.modalService.dismissAll();
        this._getServiceData();
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong please try again latter');
      },
    });
  }
  private _getServiceData() {
    this.auth
      .getShopProductDetails({ productId: this.serviceData?.id, isForPage: 1 })
      .subscribe({
        next: (data) => {
          this.serviceData = data.body;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error could not find the product data');
          this.loading = false;
          this.cdr.detectChanges();
        },
      });
  }

  public isAdmin = false;

  public openChangeProductPageInfo(event) {
    event.stopPropagation(); //no diamonds here
    if (!this.isAdmin && this.serviceData?.memberId != this.user.id) {
      return; //doesnt have a claim
    }

    this.bottomSheet.open(this.changeProductPageInfo, {
      panelClass: 'bottom-sheet-2',
    });
    //this.local.fixModalZIndexes()
  }
  closeModal() {
    if (this.modalService) {
      this.modalService.dismissAll();
    }
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
}
